import { type ApolloError, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import type { ApplicationRemarkType } from '../createNomination';

type GetApplicationStatus = {
  applicationStatus: string;
  remarks: ApplicationRemarkType[];
  loading: boolean;
  error: ApolloError | undefined;
};

export const getApplicationStatus = (id: string): GetApplicationStatus => {
  const { data, loading, error } = useQuery(
    gql`
      query ($id: ID!) {
        application(id: $id) {
          status
          remarks {
            fromRole
            toRole
            remark
            createdAt
          }
        }
      }
    `,
    {
      variables: { id },
      skip: !id,
      fetchPolicy: 'network-only',
    },
  );

  const { status, remarks: returnRemarks } = data?.application ?? '';
  const applicationStatus: string = status;
  const remarks: ApplicationRemarkType[] = returnRemarks ?? [];

  return { applicationStatus, remarks, loading, error };
};
